import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { BotaoLink } from '../../componentes/ui';
import base from './publico.module.css';
import css from './Secoes.module.css';

export function ChamadaFinal({ logado }: { logado: boolean }) {
  return (
    <section className={css.final}>
      <div className={base.conteudo}>
        <div className={css.finalCaixa}>
          <div className={css.finalTexto}>
            <h2>Feche o mês sem caçar XML.</h2>
            <p>
              Criar a conta é grátis. Suba um SPED, veja quantas notas tem e
              quanto custa — antes de gastar qualquer crédito.
            </p>
          </div>
          <div className={css.finalAcoes}>
            <BotaoLink
              to={logado ? '/painel' : '/criar-conta'}
              data-clique="criar-conta-final"
              aparencia="destaque"
              grande
              iconeDireita={<ArrowRight />}
            >
              {logado ? 'Ir para o painel' : 'Criar conta grátis'}
            </BotaoLink>
            {!logado && (
              <Link to="/entrar" className={css.finalLink}>
                Já tem conta? Entrar
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
